export const PATHTRUSTEDCERTIFICATES = '/ca';
export const pathT = 'pkcs11:/smarttoken/demo'
export const path = 'pkcs11:/smarttoken'
export const gPathCertificate= 'pkcs11:/smarttoken' 
export const gPathKeyContainer = path
export const gPathTrustedCertificates = path + PATHTRUSTEDCERTIFICATES;
 